import * as React from 'react';

import { TReview } from 'types/review';

export const MAX_MESSAGE_LENGTH = 200;

type TProps = {
  maxMessageLength?: number;
  review: TReview;
};

type TReturn = Omit<TReview, 'message'> & {
  message: string;
  isFullMessageDisplayed: boolean;
  showFullMessage: () => void;
};

export const useReview = ({
  maxMessageLength = MAX_MESSAGE_LENGTH,
  review,
}: TProps): TReturn => {
  const messageText = review.message || '';
  const hasLongMessage = messageText.length > maxMessageLength;
  const [isFullMessageDisplayed, setIsFullMessageDisplayed] = React.useState(
    !hasLongMessage,
  );

  const showFullMessage = () => {
    setIsFullMessageDisplayed(!isFullMessageDisplayed);
  };

  const message =
    hasLongMessage && !isFullMessageDisplayed
      ? `${messageText.slice(0, maxMessageLength)}...`
      : messageText;

  return {
    ...review,
    message,
    isFullMessageDisplayed,
    showFullMessage,
  };
};
